module.exports = __webpack_public_path__ + "assets/PL.d7f6741d9d63c0ad0d27423a1404dd1b.png";